import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import EmitEchekSummaryBody from "./components/Summary";

const EmitEcheckSummaryPage = (props) => {
    const { emitEcheqData, echeqsToEmit } = useSelector((state) => state.echecks);
    const { echeckTicket } = useSelector((state) => state.echecks);
    const { isDesktop } = props;
    useConfirmTransaction(emitEcheqData, echeckTicket, "echecks/emit");

    return (
        <>
            <Notification scopeToShow="echecks/emit/confirm" />
            <ResponsiveHeader id="echecks.emit" />
            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id="echecks.summary.confirm" />
                    </h2>
                    <EmitEchekSummaryBody
                        idAccount={emitEcheqData?.idAccount}
                        beneficiary={emitEcheqData.beneficiary}
                        echeqsToEmit={echeqsToEmit}
                        mode={emitEcheqData.mode}
                        character={emitEcheqData.character}
                        concept={emitEcheqData.concept}
                        motive={emitEcheqData.motive}
                        reference={emitEcheqData.reference}
                        isDesktop={isDesktop}
                    />
                    <GeneralCredentialForm
                        transactionData={emitEcheqData}
                        action={echeckActions.emitEcheq}
                        idActivity="emit.echeq.pre.activity"
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default EmitEcheckSummaryPage;
